// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Link,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";
import apiUrl from "variables/api";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { useColorMode } from "@chakra-ui/react";
export default function AdminNavbar(props) {
  const { colorMode } = useColorMode();
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [recrutation, setRecrutation] = useState("");

  useEffect(() => {
    axios.get(apiUrl + '/data/recrutation', {
      headers: {'x-access-token': localStorage.getItem('token')},
    })
    .then(response => {
        setRecrutation({
          groupName: response.data.groupName,
          link: response.data.link,
        });
    })
    .catch(error => {
      console.error(error);
      toast.error('Napotkano błąd podczas pobierania danych z API');
    });
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  });

  const {
    variant,
    children,
    fixed,
    secondary,
    brandText,
    category,
    onOpen,
    ...rest
  } = props;

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = useColorModeValue("gray.700", "gray.200");
  let secondaryText = useColorModeValue("gray.700", "gray.200");
  let navbarPosition = "absolute";
  let navbarFilter = "none";
  let navbarBackdrop = "none";
  let navbarShadow = "none";
  let navbarBg = "none";
  let navbarBorder = "transparent";
  let secondaryMargin = "0px";
  let paddingX = "15px";
  if (props.fixed === true)
    if (scrolled === true) {
      navbarPosition = "fixed";
      navbarShadow = useColorModeValue(
        "0px 7px 23px rgba(0, 0, 0, 0.05)",
        "none"
      );
      navbarBg = useColorModeValue(
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)",
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
      );
      navbarBorder = useColorModeValue("#FFFFFF", "rgba(255, 255, 255, 0.31)");
      navbarFilter = useColorModeValue(
        "none",
        "drop-shadow(0px 7px 23px rgba(0, 0, 0, 0.05))"
      );
    }

  // if (props.secondary) {
  //   navbarBackdrop = "none";
  //   navbarPosition = "absolute";
  //   mainText = "white";
  //   secondaryText = "white";
  //   secondaryMargin = "22px";
  //   paddingX = "30px";
  // }
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <Flex
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: "center" }}
      borderRadius="16px"
      display="flex"
      minH="75px"
      justifyContent={{ xl: "center" }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pb="8px"
      left=""
      right="30px"
      px={{
        sm: paddingX,
        md: "30px",
      }}
      ps={{
        xl: "15px",
      }}
      pt="8px"
      top="18px"
      w={{ sm: "calc(100vw - 30px)", xl: "calc(100vw - 75px - 275px)" }}
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: "column",
          md: "row",
        }}
        ml={{sm: '15px', md: '0px'}}
        alignItems={{ xl: "center" }}
      >
        <Box mb={{ sm: "8px", md: "0px" }}>
          <Breadcrumb>
            <BreadcrumbItem color={mainText}>
              <BreadcrumbLink href="#" color={secondaryText}>
                SWD
              </BreadcrumbLink>
            </BreadcrumbItem>

            {category && (
              <BreadcrumbItem color={mainText}>
                <BreadcrumbLink href="#" color={mainText}>
                  {category}
                </BreadcrumbLink>
              </BreadcrumbItem>
            )}

            <BreadcrumbItem color={mainText}>
              <BreadcrumbLink href="#" color={mainText}>
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Link
            color={mainText}
            href="#"
            bg="inherit"
            borderRadius="inherit"
            fontWeight="bold"
            _hover={{ color: { mainText } }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            {brandText}
          </Link>
        </Box>
        {recrutation && recrutation.groupName !== "Brak" && !isMobile && (
        <Flex ms={"auto"} direction={{md: 'column', xl: 'row'}} gap={"6px"} backgroundColor={"red.600"} p={"8px 20px"} alignItems={"center"} boxShadow={"0px 5px 14px rgba(0, 0, 0, 0.05)"} borderRadius={"20px"} color={"white"}>
          <Text fontSize="md" fontWeight="bold">
            Aktualnie jest otwarta rekrutacja do grupy {recrutation.groupName}
          </Text> 
          {recrutation.link && (
          <Link href={recrutation.link} target="_blank">Kliknij, aby dowiedzieć się więcej</Link>
          )}
        </Flex>
        )}
        <Box ms="auto" w={{ sm: "100%", md: "unset" }}>
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
          />
        </Box>
      </Flex>
    </Flex>
  );
}
